import { render } from "./ReferralInbox.vue?vue&type=template&id=4a61e0f4&scoped=true"
import script from "./ReferralInbox.vue?vue&type=script&lang=js"
export * from "./ReferralInbox.vue?vue&type=script&lang=js"

import "./ReferralInbox.vue?vue&type=style&index=0&id=4a61e0f4&lang=css"
import "./ReferralInbox.vue?vue&type=style&index=1&id=4a61e0f4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a61e0f4"]])

export default __exports__